import { VaultListTagWrapper } from "./VaultListTags.styles"

export const VaultPeriodTag = ({ period }) => {
    return (
        <VaultListTagWrapper>
            <div>{period}</div>
        </VaultListTagWrapper>
    )
}